import React from 'react';
// import i18next from 'i18next';
// import en from './i18n/en';

// import ptBr from './i18n/pt-br';

// i18next.addResourceBundle('pt-br', 'visaoGeral', ptBr);
// i18next.addResourceBundle('en', 'visaoGeral', en);

const PublicoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: null,
  routes: [
    {
      path: '/public/pedido-compra/:uuid',
      component: React.lazy(() => import('./visualizarPedidoCompra')),
    },
    {
      path: '/public/pedido-venda/:uuid',
      // path: '/assets/html/visualizador.html',
      component: React.lazy(() => import('./visualizarPedidoVenda')),
    },
    {
      path: '/public/conta-receber/:uuid',
      // path: '/assets/html/visualizador.html',
      component: React.lazy(() => import('./visualizarBoleto')),
    },
    {
      path: '/public/primeiro-acesso',
      component: React.lazy(() => import('./primeiroacesso/PrimeiroAcesso')),
    },
    {
      path: '/public/recuperar-senha',
      component: React.lazy(() => import('./login/PublicRecuperarSenha')),
    },
    {
      path: '/public/confirmar-email',
      component: React.lazy(() => import('./login/PublicConfirmarEmail')),
    },
    {
      path: '/public/atualizar-senha',
      component: React.lazy(() => import('./login/PublicAtualizarSenha')),
    },
    {
      path: '/public/sessao-bloqueada',
      component: React.lazy(() => import('./login/PublicSessaoBloqueada')),
    },
    {
      path: '/public/logout',
      component: React.lazy(() => import('./logout/PublicLogout')),
    },
    {
      path: '/public/termo-de-uso',
      component: React.lazy(() => import('./termodeuso/PublicTermoDeUso')),
    },
    {
      path: '/public/relatorio/pdf',
      component: React.lazy(() => import('./PDF/Visualizador')),
    },
  ],
};

export default PublicoConfig;
